import { CopyRightsText, CopyRightsTextWrapper } from "./element";

function CopyRightsTextCom() {
  return (
    <CopyRightsTextWrapper>
      <CopyRightsText>
        Copyrights © {new Date().getFullYear()} All rights reserved
      </CopyRightsText>
    </CopyRightsTextWrapper>
  );
}

export default CopyRightsTextCom;
